import React from 'react';
import theme from '~/theme';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BaseLink from '~/components/base/BaseLink';
import Icon from '~/components/base/Icon';

import { sanitizeAndParseHTML } from '~/utilities/helpers';
import { h3, medium } from '~/styles/typography';
import { transition } from '~/styles/transition';

const Card = styled(BaseLink)`
    display: block;
    padding: 15px 20px;
    background-color: ${theme.colors.primary.white};
    height: 100%;

    outline-offset: 0px;

    ${transition({}, 'box-shadow')};

    &:hover {
        box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.2);
    }

    @media (min-width: ${theme.breakpoint.tablet}) {
        padding: 30px;
    }
`;

const Header = styled.div`
    display: flex;
    gap: 20px;

    @media (max-width: ${theme.breakpoint.largePhoneMax}) {
        align-items: center;
    }
`;

const Title = styled.span`
    ${h3};

    @media (min-width: ${theme.breakpoint.largeTablet}) {
        font-size: 2.9rem;
    }
`;

const Excerpt = styled.p`
    margin-top: 20px;
    ${medium};
    font-weight: ${theme.fontWeights.bold};

    @media (max-width: ${theme.breakpoint.largePhoneMax}) {
        display: none;
    }
`;

const LinkCard = ({ title, subtitle, icon, link }) => (
    <Card to={link.uri}>
        <Header>
            {icon && (
                <Icon
                    {...{ icon }}
                    color="black"
                    sizeMobile={25}
                    sizeTablet={28}
                    size={30}
                    sizeLarge={34}
                />
            )}
            <Title>{title}</Title>
        </Header>
        {subtitle && <Excerpt>{sanitizeAndParseHTML(subtitle)}</Excerpt>}
    </Card>
);

LinkCard.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    icon: PropTypes.string,
    link: PropTypes.shape({
        uri: PropTypes.string.isRequired
    }).isRequired
};

export default LinkCard;
